// components/portal/ResearchRowStyles.tsx
//
// During a research run, the shortlist rows say where each brand stands without opening it: the
// brands being researched are highlighted and pulse, the ones not reached yet are dimmed (owner,
// 2026-09-26). Read off the campaign's own progress (the worker writes it), styled through the
// rows' data-table-row-id so the shared Table stays untouched.
import React from 'react';
import { useKernelStore } from '@/kernel/kernelStores';
import { readCampaignRow } from '#lib/leasing/campaignRow';
import { activeCampaignResearch } from '#lib/leasing/researchPass';

export const ResearchRowStyles = ({ campaignId }: { campaignId: string | null | undefined }) => {
  const css = useKernelStore((state) => {
    const research = campaignId ? activeCampaignResearch(readCampaignRow(state.inventory, campaignId)) : null;
    if (!research) return '';
    const current: string[] = [];
    const waiting: string[] = [];
    for (const lead of Object.values(state.inventory.Lead.registry) as Array<{ id?: string; brandId?: string; lastCampaignId?: string | null } | undefined>) {
      if (!lead?.id || !lead.brandId || lead.lastCampaignId !== campaignId) continue;
      if (research.current.includes(lead.brandId)) current.push(lead.id);
      else if (!research.done.includes(lead.brandId)) waiting.push(lead.id);
    }
    const row = (leadId: string) => `[data-table-row-id="${leadId}"]`;
    return [
      // min-width: the row block is only as wide as the viewport, so on a table scrolled sideways
      // the highlight stopped mid-row (owner, 2026-09-26); the grid's own width is the table's.
      current.length ? `${current.map(row).join(', ')} { animation: researchRowPulse 1.8s ease-in-out infinite; border-radius: 8px; min-width: var(--table-min-width, 100%); }` : '',
      waiting.length ? `${waiting.map(row).join(', ')} { opacity: 0.4; }` : '',
      '@keyframes researchRowPulse { 0%, 100% { background-color: rgba(59, 130, 246, 0.06); } 50% { background-color: rgba(59, 130, 246, 0.2); } }',
    ].join('\n');
  });
  return css ? <style>{css}</style> : null;
};
